<template>
  <div
    class="foot-main"
    :style="{background: isback ? '#fff' : ''}"
  >
    <cube-button
      @click="handleCacel"
      v-text="cacelText"
    />
    <cube-button
      type="submit"
      :disabled="disabled"
      @click="handleSure"
      v-text="okText"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import i18n from '@/lib/language'
export default {
  props: {
    okText: {
      type: String,
      default: i18n.t('message["915"]')
    },
    cacelText: {
      type: String,
      default: i18n.t('message["896"]')
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 是否需要白色背景
    isback: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleCacel () {
      this.$emit('cacel')
    },
    handleSure () {
      this.$emit('ok')
    }
  }
}
</script>

<style scoped lang="scss">
.foot-main {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 62px;
  z-index: 99;
  button {
    display: inline-block;
    width: 176px;
    height: 46px;
    box-sizing: border-box;
    background: #fff;
    border:1px solid rgba(219,219,219,1);
    color: #333;
    margin: 8px;
  }
  button[type="submit"] {
    margin: 8px 0 0 0;
    background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
    box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
    border-radius:4px;
    border:1px solid rgba(80,119,170,1);
    color: #fff
  }
}
</style>
